import { useAppContext } from "@data-root/react";
import { DashboardView } from "@/views/DashboardView";
import { DashboardView as IDashboardView } from "@data-root/types";
import { useMemo } from "react";

export const DashboardPlayground = () => {
  const { tables } = useAppContext();

  const view: IDashboardView = useMemo(
    () => ({
      id: "__dashboard",
      name: "AI Playground",
      description: "AI Playground",
      type: "Dashboard",
      icon: "DashboardOutlined",
      tableId: tables[0].id,
      options: {
        layouts: [],
        groups: [],
      },
    }),
    [tables]
  );

  return <DashboardView view={view} />;
};
